"use strict";

exports.__esModule = true;
exports.typeXXXSmall = exports.typeXXSmall = exports.typeXTiny = exports.typeXSmall = exports.typeXLarge = exports.typeTiny = exports.typeSmall = exports.typeNormal = exports.typeMedium = exports.typeLarge = exports.typeBody = exports.header = void 0;

var _styledComponents = require("styled-components");

var _mediaQueries = _interopRequireDefault(require("./media-queries"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var typeXLarge = function typeXLarge(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:40px;font-weight:", ";line-height:1;margin-bottom:0.25em;", ";", ";", ";", ";"], fontWeight, _mediaQueries["default"].phablet(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["font-size: 46px;"]))), _mediaQueries["default"].lap(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["font-size: 52px;"]))), _mediaQueries["default"].desk(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["font-size: 60px;"]))), _mediaQueries["default"].deskWide(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["font-size: 70px;"]))));
};

exports.typeXLarge = typeXLarge;

var typeLarge = function typeLarge(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:34px;font-weight:", ";line-height:1;margin-bottom:0.333em;", ";", ";", ";", ";"], fontWeight, _mediaQueries["default"].phablet(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["font-size: 38px;"]))), _mediaQueries["default"].lap(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["font-size: 42px;"]))), _mediaQueries["default"].desk(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["font-size: 50px;"]))), _mediaQueries["default"].deskWide(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["font-size: 60px;"]))));
};

exports.typeLarge = typeLarge;

var typeMedium = function typeMedium(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:32px;font-weight:", ";line-height:1;margin-bottom:0.4em;", " ", " ", " ", ";"], fontWeight, _mediaQueries["default"].phablet(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["font-size: 34px;"]))), _mediaQueries["default"].lap(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["font-size: 38px;"]))), _mediaQueries["default"].desk(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["font-size: 44px;"]))), _mediaQueries["default"].deskWide(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["font-size: 50px;"]))));
};

exports.typeMedium = typeMedium;

var typeNormal = function typeNormal(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:24px;font-weight:", ";line-height:1;margin-bottom:0.5em;", ";", ";", ";", ";"], fontWeight, _mediaQueries["default"].phablet(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["font-size: 26px;"]))), _mediaQueries["default"].lap(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["font-size: 28px;"]))), _mediaQueries["default"].desk(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["font-size: 34px;"]))), _mediaQueries["default"].deskWide(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["font-size: 36px;"]))));
};

exports.typeNormal = typeNormal;

var typeSmall = function typeSmall(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:22px;font-weight:", ";line-height:1;margin-bottom:0.5em;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["font-size: 24px;"]))), _mediaQueries["default"].desk(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["font-size: 28px;"]))));
};

exports.typeSmall = typeSmall;

var typeBody = function typeBody(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:18px;font-weight:", ";line-height:1.2;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["font-size: 20px;"]))), _mediaQueries["default"].desk(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["font-size: 21px;"]))));
};

exports.typeBody = typeBody;

var typeXSmall = function typeXSmall(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:20px;font-weight:", ";line-height:1;margin-bottom:0.85em;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["font-size: 22px;"]))), _mediaQueries["default"].desk(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["font-size: 24px;"]))));
};

exports.typeXSmall = typeXSmall;

var typeXXSmall = function typeXXSmall(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:16px;font-weight:", ";line-height:1;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["font-size: 17px;"]))), _mediaQueries["default"].desk(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["font-size: 18px;"]))));
};

exports.typeXXSmall = typeXXSmall;

var typeXXXSmall = function typeXXXSmall(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:14px;font-weight:", ";line-height:1;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["font-size: 15px;"]))), _mediaQueries["default"].desk(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["font-size: 16px;"]))));
};

exports.typeXXXSmall = typeXXXSmall;

var typeTiny = function typeTiny(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:12px;font-weight:", ";line-height:1.3em;", ";", ";"], fontWeight, _mediaQueries["default"].lap(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["font-size: 13px;"]))), _mediaQueries["default"].desk(_templateObject28 || (_templateObject28 = _taggedTemplateLiteralLoose(["font-size: 14px;"]))));
};

exports.typeTiny = typeTiny;

var typeXTiny = function typeXTiny(fontWeight) {
  if (fontWeight === void 0) {
    fontWeight = 400;
  }

  return (0, _styledComponents.css)(["font-size:12px;font-weight:", ";line-height:1.2em;"], fontWeight);
};

exports.typeXTiny = typeXTiny;

var header = function header(headerName, alt) {
  if (alt === void 0) {
    alt = false;
  }

  if (headerName === "h1") {
    return (0, _styledComponents.css)(["font-size:32px;font-weight:600;line-height:1;margin-bottom:0.25em;", ";", ";", ";"], _mediaQueries["default"].phablet(_templateObject29 || (_templateObject29 = _taggedTemplateLiteralLoose(["font-size: 34px;"]))), _mediaQueries["default"].lap(_templateObject30 || (_templateObject30 = _taggedTemplateLiteralLoose(["font-size: 36px;"]))), _mediaQueries["default"].desk(_templateObject31 || (_templateObject31 = _taggedTemplateLiteralLoose(["font-size: 42px;"]))));
  }

  if (headerName === "h2") {
    return (0, _styledComponents.css)(["font-size:30px;font-weight:", ";line-height:1;margin-bottom:0.375em;", ";", ";", ";"], alt ? 200 : 600, _mediaQueries["default"].phablet(_templateObject32 || (_templateObject32 = _taggedTemplateLiteralLoose(["font-size: 32px;"]))), _mediaQueries["default"].lap(_templateObject33 || (_templateObject33 = _taggedTemplateLiteralLoose(["font-size: 34px"]))), _mediaQueries["default"].desk(_templateObject34 || (_templateObject34 = _taggedTemplateLiteralLoose(["font-size: 42px"]))));
  }

  if (headerName === "h3") {
    return (0, _styledComponents.css)(["font-size:28px;font-weight:600;line-height:1;margin-bottom:0.2em;", ";", ";", ";"], _mediaQueries["default"].phablet(_templateObject35 || (_templateObject35 = _taggedTemplateLiteralLoose(["font-size: 30px;"]))), _mediaQueries["default"].lap(_templateObject36 || (_templateObject36 = _taggedTemplateLiteralLoose(["font-size: 32px;"]))), _mediaQueries["default"].desk(_templateObject37 || (_templateObject37 = _taggedTemplateLiteralLoose(["font-size: 36px;"]))));
  }

  if (headerName === "h4") {
    return (0, _styledComponents.css)(["font-size:20px;font-weight:600;line-height:1;margin-bottom:0.25em;", ";", ";", ";"], _mediaQueries["default"].phablet(_templateObject38 || (_templateObject38 = _taggedTemplateLiteralLoose(["font-size: 22px;"]))), _mediaQueries["default"].lap(_templateObject39 || (_templateObject39 = _taggedTemplateLiteralLoose(["font-size: 24px;"]))), _mediaQueries["default"].desk(_templateObject40 || (_templateObject40 = _taggedTemplateLiteralLoose(["font-size: 30px;"]))));
  }

  if (headerName === "h5") {
    return (0, _styledComponents.css)(["font-size:20px;font-weight:400;line-height:1.2;margin-bottom:0.25em;", ";", ";", ";"], _mediaQueries["default"].phablet(_templateObject41 || (_templateObject41 = _taggedTemplateLiteralLoose(["font-size: 21px;"]))), _mediaQueries["default"].lap(_templateObject42 || (_templateObject42 = _taggedTemplateLiteralLoose(["\n        font-size: ", "px;\n      "])), alt ? 21 : 22), _mediaQueries["default"].desk(_templateObject43 || (_templateObject43 = _taggedTemplateLiteralLoose(["\n        font-size: ", "px;\n      "])), alt ? 21 : 24));
  }

  if (headerName === "h6") {
    return (0, _styledComponents.css)(["font-size:16px;font-weight:400;line-height:1.2;margin-bottom:0;", ";", ";"], _mediaQueries["default"].phablet(_templateObject44 || (_templateObject44 = _taggedTemplateLiteralLoose(["font-size: 17px;"]))), _mediaQueries["default"].lap(_templateObject45 || (_templateObject45 = _taggedTemplateLiteralLoose(["font-size: 18px;"]))));
  }

  if (headerName === "h7") {
    return (0, _styledComponents.css)(["font-size:20px;font-weight:600;margin-bottom:0.25em;", ";", ";", ";"], _mediaQueries["default"].phablet(_templateObject46 || (_templateObject46 = _taggedTemplateLiteralLoose(["font-size: 22px;"]))), _mediaQueries["default"].lap(_templateObject47 || (_templateObject47 = _taggedTemplateLiteralLoose(["font-size: 24px;"]))), _mediaQueries["default"].desk(_templateObject48 || (_templateObject48 = _taggedTemplateLiteralLoose(["font-size: 26px;"]))));
  }

  return (0, _styledComponents.css)(["font-size:30px;font-weight:", ";line-height:1;margin-bottom:0.375em;", ";", ";", ";"], alt ? 200 : 600, _mediaQueries["default"].phablet(_templateObject49 || (_templateObject49 = _taggedTemplateLiteralLoose(["font-size: 32px;"]))), _mediaQueries["default"].lap(_templateObject50 || (_templateObject50 = _taggedTemplateLiteralLoose(["font-size: 34px"]))), _mediaQueries["default"].desk(_templateObject51 || (_templateObject51 = _taggedTemplateLiteralLoose(["font-size: 42px"]))));
};

exports.header = header;